import React, { useState } from "react";
import { useParams } from "react-router-dom";
import Spinner from "../../Components/Spinner";

const BuildChoice = ({ setContext }) => {
    const user_id = sessionStorage.getItem("user_id");
    const { project_id } = useParams();
    const [loading, setLoading] = useState(false);

    const [selectedContext, setSelectedContext] = useState(null);
    const [webappChoice, setWebappChoice] = useState(null);
    const [step, setStep] = useState(1); // 1 = main choice, 2 = webapp choice

    const setContextFun = async (contextValue) => {
        setLoading(true);
        console.log(user_id, project_id, contextValue)
        try {
            const response = await fetch("https://backend.erioon.com/set_context", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ user_id, project_id, selectedContext: contextValue }),
            });

            if (!response.ok) throw new Error("Failed to fetch codebase");

            const data = await response.json();
            if (data.message === "OK") {
                setTimeout(() => {
                    setContext(contextValue);
                }, 800);
            } else {
                console.log("KO");
            }
        } catch (error) {
            console.error(error);
        } finally {
            setTimeout(() => {
                setLoading(false);
            }, 800);
        }
    };

    const mainCards = [
        {
            value: "serverless",
            title: "Web Application",
            sub: "Create a full-featured, interactive web app with modern UI and backend integration.",
        },
        // {
        //     value: "mobile",
        //     title: "Mobile App",
        //     sub: "Create a full-featured, interactive mobile app for iOS and Android.",
        // },
        // {
        //     value: "api",
        //     title: "API Service",
        //     sub: "Build a robust, scalable API to power web, mobile, or third-party integrations.",
        // },
    ];

    const webappCards = [
        {
            value: "serverless",
            title: "Serverless",
            sub: "Frontend-only app with a managed backend (REST API handled for you).",
        }
    ];

    const handleNext = () => {
        if (step === 1) {
            if (selectedContext === "serverless") {
                setContextFun("serverless")
            }else if (selectedContext == "mobile"){
                setContextFun("mobile")
            }
        }
    };

    return (
        <div className="build_choice_cont">
            {step === 1 && (
                <div className="build_choice_container">
                    <p className="initializing_project_title fade-in">
                        Choose your codespace type
                    </p>
                    <p className="initializing_project_sub fade-in">
                        This helps the AI understand your goals and tailor the setup accordingly.
                    </p>

                    <div className="build_choice_card_cont">
                        {mainCards.map((card) => (
                            <div
                                key={card.value}
                                className={`build_choice_card fade-in ${selectedContext === card.value ? "build_choice_card_selected" : ""
                                    }`}
                                onClick={() => setSelectedContext(card.value)}
                            >
                                <p className="build_choice_title">{card.title}</p>
                                <p className="build_choice_sub">{card.sub}</p>
                            </div>
                        ))}
                    </div>
                    {/* <div className="coming_soon_cont">
                        <p className="coming_soon_cont_title">Coming Soon</p>
                        <p className="coming_soon_parag">
                            <strong>Mobile Apps</strong> — Build and deploy native iOS and Android applications seamlessly.
                        </p>
                        <p className="coming_soon_parag">
                            <strong>Agents</strong> — Create autonomous AI assistants that can reason, plan, and execute real-world operations.
                        </p>
                        <p className="coming_soon_parag">
                            <strong>Functions</strong> — Write, test, and deploy serverless functions in a dedicated compute environment.
                        </p>
                    </div> */}


                    {selectedContext && (
                        <div className="build_choice_btn_cont">
                            <button
                                className="build_choice_btn fade-in"
                                onClick={handleNext}
                                disabled={loading}
                            >
                                {loading ? (
                                    <Spinner loading={loading} />
                                ) : (
                                    <>
                                        Next <i className="fa-solid fa-chevron-right"></i>
                                    </>
                                )}
                            </button>
                        </div>
                    )}
                </div>
            )}

        </div>
    );
};

export default BuildChoice;
